export var Os;
(function (Os) {
    Os["Mac"] = "Mac";
    Os["Windows"] = "Windows";
    Os["Linux"] = "Linux";
    Os["AWS_Cloudformation"] = "AWS_Cloudformation";
    Os["GCP"] = "GCP";
    Os["Fetcher"] = "Fetcher";
    Os["Helm"] = "Helm";
})(Os || (Os = {}));
//# sourceMappingURL=os.enum.js.map